var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-row',[_c('b-col',[_c('p',{attrs:{"id":"logo"}},[_c('img',{attrs:{"src":require("@/assets/img/Otelico-logo-text-bleu.png")}})])])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }